import React from 'react';
import { useTranslation } from 'react-i18next';
import { formatNumber } from '../utils/format';

const DashboardWidget = ({ title, value, subtitle, icon, color, trend, onClick, details }) => {
  const { t } = useTranslation();
  const colorClasses = {
    blue: 'from-blue-500 to-blue-600',
    green: 'from-green-500 to-green-600',
    purple: 'from-purple-500 to-purple-600',
    orange: 'from-orange-500 to-orange-600',
    red: 'from-red-500 to-red-600',
    indigo: 'from-indigo-500 to-indigo-600',
    pink: 'from-pink-500 to-pink-600',
    yellow: 'from-yellow-500 to-yellow-600',
    teal: 'from-teal-500 to-teal-600',
    cyan: 'from-cyan-500 to-cyan-600',
    sky: 'from-sky-500 to-sky-600',
    violet: 'from-violet-500 to-violet-600',
    rose: 'from-rose-500 to-rose-600',
    amber: 'from-amber-500 to-amber-600',
    emerald: 'from-emerald-500 to-emerald-600',
    slate: 'from-slate-500 to-slate-600'
  };

  const gradientClass = colorClasses[color] || colorClasses.blue;

  return (
    <div 
      className={`bg-gradient-to-br ${gradientClass} rounded-xl shadow-lg p-6 text-white cursor-pointer transform hover:scale-105 transition-all duration-200`}
      onClick={onClick}
    >
      <div className="flex items-center justify-between mb-4">
        <div className="flex-1">
          <p className="text-white text-opacity-90 text-sm font-medium mb-1">{title}</p>
          <p className="text-3xl font-bold">{value}</p>
          {subtitle && (
            <p className="text-white text-opacity-75 text-xs mt-1">{subtitle}</p>
          )}
        </div>
        {icon && (
          <div className="bg-white dark:bg-surface-900 bg-opacity-20 rounded-full p-3">
            <span className="text-2xl">{icon}</span>
          </div>
        )}
      </div>
      
      {/* Detailed breakdown */}
      {details && details.length > 0 && (
        <div className="mt-4 pt-4 border-t border-white border-opacity-20 space-y-2">
          {details.map((detail, index) => (
            <div key={index} className="flex justify-between items-center text-sm">
              <span className="text-white text-opacity-80">{detail.label}:</span>
              <span className={`font-semibold ${detail.highlight ? 'text-yellow-200' : 'text-white'}`}>
                {detail.value}
              </span>
            </div>
          ))}
        </div>
      )}
      
      {trend && (
        <div className="flex items-center text-sm mt-3">
          <span className={`me-1 ${trend.direction === 'up' ? 'text-green-200' : 'text-red-200'}`}>
            {trend.direction === 'up' ? '↑' : '↓'}
          </span>
          <span className="text-white text-opacity-90">
            {t('shared.dashboardWidget.trendThisMonth', { percentage: formatNumber(trend.percentage, { maximumFractionDigits: 1 }) })}
          </span>
        </div>
      )}
    </div>
  );
};

export default DashboardWidget;
